import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MsGraphApiService } from './service/ms-graph-api.service';
import { MsGraphApiHelper } from './helper/ms-graph-api.helper';

@NgModule({
  providers: [MsGraphApiService, MsGraphApiHelper],
  imports: [CommonModule]
})
export class MsGraphApiModule {}
